import useStudentFilterForm from 'Pages/student/hooks/useStudentFilterForm'
import { CategoryInput } from '../../../../common/form/input/_categoryInput'

export const StudentInfo = () => {
  const { studentInfo } = useStudentFilterForm()
  return (
    <CategoryInput
      className={'student-filter-form__input-wide'}
      categoryList={[]}
      categoryValue={{ name: 'Khách hàng', value: '' }}
      categoryWidth={100}
      placeholder='Tên khách hàng/Số điện thoại'
      value={studentInfo?.value || ''}
      onChange={studentInfo.onChange}
      style={{ position: 'relative' }}
    />
  )
}
